<script>
  import { setContext } from "svelte";

  let { content, currentUser } = $props();

  // contexts
  setContext("currentUser", currentUser);
</script>

<div>
  {@render content({ currentUser })}
</div>
